<template>

	<div class="contant">
		<div class="content">
			<div style="background-image: linear-gradient(45deg, rgb(57, 181, 74), rgb(8, 121, 0));">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style="height: 45px;padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">{{ $t('hangqing') }}</div>
					</div>
				</div>
			</div>
			<div class="padding" style="#000">
				<div class="cu-list menu-avatar">
					<div v-for="(item, index) in dailyCommodityList" :key="index"
						class="cu-item bg-gradual-black bg-blue animation-scale-up"
						style="border-radius: 10px; margin-top: 3px;">
						<div class="cu-avatar round lg" :style="{
                       backgroundColor: 'transparent',
                       backgroundImage: `url(${item.image})`
                     }"></div>
						<div class="content" style="left: 60px;">
							<div class="text-xl">
								<div class="round margin-left">{{ item.name }}</div>
							</div>
							<div class="text-gray text-xs">
								<div class="round margin-left">{{ item.exchange }}</div>
							</div>
						</div>
						<div class="flex" style="margin-right: 5px;">
							<div class="text-xl">${{ item.price }}</div>
						</div>
						<div class="action" style="width: 100px;">
							<div class="cu-tag round"
								:class="item.changeRate.includes('+') ? 'bg-gradual-red' : 'bg-gradual-green'"
								style="min-width: 80px; font-size: 16px;">
								{{ item.changeRate }}
							</div>
						</div>
					</div>
				</div>
				<div style="height: 50px;"></div>
			</div>


		</div>

	</div>

	<tab-bar></tab-bar>

</template>

<script>
	// @ is an alias to /src

	import TabBar from "@/components/tabbar/TabBar.vue";

	export default {
		name: "Find",
		components: {
			TabBar,
		},
		data() {
			return {
				data: [],
				gameList: "",
				commodityList: [{
						image: require('@/assets/home/1.jpg'),
						name: "GOLD",
						exchange: "COMEX",
						price: "3322.60",
						changeRate: "-0.61%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2605",
						exchange: "NYMEX",
						price: "62.23",
						changeRate: "1.00%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2609",
						exchange: "NYMEX",
						price: "62.04",
						changeRate: "-1.56%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2608",
						exchange: "NYMEX",
						price: "62.06",
						changeRate: "2.10%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2607",
						exchange: "NYMEX",
						price: "62.11",
						changeRate: "1.36%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2611",
						exchange: "NYMEX",
						price: "62.06",
						changeRate: "0.00%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2610",
						exchange: "NYMEX",
						price: "62.04",
						changeRate: "1.78%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2606",
						exchange: "NYMEX",
						price: "61.66",
						changeRate: "-0.84%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2604",
						exchange: "NYMEX",
						price: "61.72",
						changeRate: "-0.92%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2603",
						exchange: "NYMEX",
						price: "61.75",
						changeRate: "-0.98%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2602",
						exchange: "NYMEX",
						price: "61.86",
						changeRate: "-0.99%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL 2601",
						exchange: "NYMEX",
						price: "62.03",
						changeRate: "-1.04%"
					},
					{
						image: require('@/assets/home/2.jpg'),
						name: "OIL",
						exchange: "NYMEX",
						price: "66.28",
						changeRate: "-1.07%"
					},
					{
						image: require('@/assets/home/9.png'),
						name: "BTC",
						exchange: "Bitcoin",
						price: "119351.66",
						changeRate: "+1.04%"
					},
					{
						image: require('@/assets/home/10.png'),
						name: "ETH",
						exchange: "Ethereum",
						price: "3789.98",
						changeRate: "+3.11%"
					},
					{
						image: require('@/assets/home/11.png'),
						name: "XRP",
						exchange: "XRP",
						price: "3.57",
						changeRate: "+3.77%"
					},
					{
						image: require('@/assets/home/12.png'),
						name: "USDT",
						exchange: "Tether",
						price: "1.00",
						changeRate: "-0.06%"
					},
					{
						image: require('@/assets/home/13.png'),
						name: "BNB",
						exchange: "BNB",
						price: "761.42",
						changeRate: "+2.19%"
					},
					{
						image: require('@/assets/home/14.png'),
						name: "SOL",
						exchange: "Solana",
						price: "190.03",
						changeRate: "+6.64%"
					},
					{
						image: require('@/assets/home/15.png'),
						name: "USDC",
						exchange: "USDC",
						price: "1.00",
						changeRate: "0.00%"
					},
					{
						image: require('@/assets/home/16.png'),
						name: "DOGE",
						exchange: "Dogecoin",
						price: "0.27",
						changeRate: "+8.41%"
					},
					{
						image: require('@/assets/home/17.png'),
						name: "STETH",
						exchange: "Lido Staked ETH",
						price: "3750.97",
						changeRate: "+2.91%"
					},
					{
						image: require('@/assets/home/19.png'),
						name: "ADA",
						exchange: "Cardano",
						price: "0.89",
						changeRate: "+6.04%"
					},
					{
						image: require('@/assets/home/18.png'),
						name: "TRX",
						exchange: "TRON",
						price: "0.31",
						changeRate: "-1.56%"
					},
					{
						image: require('@/assets/home/20.png'),
						name: "HYPE",
						exchange: "Hyperliquid",
						price: "46.97",
						changeRate: "+4.21%"
					},
					{
						image: require('@/assets/home/21.png'),
						name: "WBTC",
						exchange: "Wrapped Bitcoin",
						price: "119178.55",
						changeRate: "+1.00%"
					},
					{
						image: require('@/assets/home/22.png'),
						name: "XLM",
						exchange: "Stellar",
						price: "0.49",
						changeRate: "+5.31%"
					},
					{
						image: require('@/assets/home/23.png'),
						name: "SUI",
						exchange: "Sui",
						price: "4.00",
						changeRate: "+1.34%"
					},
					{
						image: require('@/assets/home/24.png'),
						name: "LINK",
						exchange: "Chainlink",
						price: "19.77",
						changeRate: "+5.21%"
					},
					{
						image: require('@/assets/home/25.png'),
						name: "WETH",
						exchange: "Wrapped ETH",
						price: "3789.98",
						changeRate: "+3.11%"
					},
					{
						image: require('@/assets/home/26.png'),
						name: "HBAR",
						exchange: "Hedera",
						price: "0.28",
						changeRate: "+5.25%"
					},
					{
						image: require('@/assets/home/28.png'),
						name: "AVAX",
						exchange: "Avalanche",
						price: "25.83",
						changeRate: "+4.61%"
					},
					{
						image: require('@/assets/home/27.png'),
						name: "BCH",
						exchange: "Bitcoin Cash",
						price: "531.57",
						changeRate: "+1.68%"
					}
				]
			};
		},
		methods: {
			generateDailyData() {
				return this.commodityList.map(item => {
					// 跳过涨跌幅为0的商品
					if (item.changeRate === "0.00%") return item;

					// 生成-1%到1%的随机涨跌幅（保留两位小数）
					const randomRate = (Math.random() * 12 - 6).toFixed(2);
					const newRate = parseFloat(randomRate);

					// 计算新价格（基于原价±1%范围内）
					const basePrice = parseFloat(item.price);
					const priceChange = basePrice * (newRate / 100);
					const newPrice = (basePrice + priceChange).toFixed(2);

					return {
						...item,
						price: newPrice.toString(),
						changeRate: `${newRate > 0 ? '+' : ''}${newRate}%`
					};
				});
			}
		},
		computed: {
			dailyCommodityList() {
				// 每天生成新数据（基于本地存储日期判断）
				const today = new Date().toDateString();
				const lastUpdate = localStorage.getItem('lastUpdate');
				if (!lastUpdate || lastUpdate !== today) {
					const newData = this.generateDailyData();
					localStorage.setItem('commodityData', JSON.stringify(newData));
					localStorage.setItem('lastUpdate', today);
					return newData;
				}
				return JSON.parse(localStorage.getItem('commodityData')) || this.commodityList;
			}
		}

	};
</script>
<style lang="less" scoped>
	.bg-gradual-red {
		background-color: #e54d42;
		color: #fff;
	}

	.cc {
		margin-left: -143px;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu-avatar>.cu-item {
		position: relative;
		display: flex;
		padding-right: 5px;
		height: 70px;
		background-color: #fff;
		justify-content: flex-end;
		align-items: center;
	}

	.cu-tag {
		font-size: 12px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 8px;
		height: 24px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.bg-gradual-green {
		background-image: linear-gradient(45deg, #39b54a, #8dc63f);
		color: #fff;
	}

	.cu-list.menu-avatar>.cu-item .action {
		width: 50px;
		text-align: center;
	}

	.text-xl {
		font-size: 18px;
	}

	.flex {
		display: flex;
	}

	.text-xs {
		font-size: 10px;
	}

	.text-gray,
	.line-gray,
	.lines-gray {
		color: #aaa;
	}

	.margin-left {
		margin-left: 15px;
	}

	.round {
		border-radius: 2500px;
	}

	.cu-list.menu-avatar>.cu-item .content>div:first-child {
		font-size: 15px;
		display: flex;
		align-items: center;
	}

	.cu-list.menu-avatar>.cu-item .content {
		position: absolute;
		text-align: left;
		display: block;
		left: 73px;
		/* width: calc(100% - 48px - 30px - 60px - 10px); */
		line-height: 1.6em;
		width: 100%;
	}

	.cu-avatar {
		font-variant: small-caps;
		margin: 0;
		padding: 0;
		display: inline-flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		background-color: #ccc;
		color: #fff;
		white-space: nowrap;
		position: relative;
		width: 32px;
		height: 32px;
		background-size: cover;
		background-position: 50%;
		vertical-align: middle;
		font-size: 1.5em;
	}

	.cu-avatar.lg {
		width: 48px;
		height: 48px;
		font-size: 2em;
	}

	.cu-list.menu-avatar>.cu-item>.cu-avatar {
		position: absolute;
		left: 15px;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu-avatar>.cu-item {
		position: relative;
		display: flex;
		padding-right: 5px;
		height: 70px;
		background-color: #fff;
		justify-content: flex-end;
		align-items: center;
	}

	.cu-list.menu-avatar {
		// overflow: hidden;
	}

	.padding {
		padding: 15px;
		color: #000;
	}

	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 50px;
		justify-content: space-between;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 220px);
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 170px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 30px;
		font-size: 16px;
		line-height: 30px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		// overflow: hidden;
	}

	.cu-custom {
		display: block;
		position: relative;
	}
</style>